export const LOGOS = {
  elephant: "/logo-elephant.png",
  full: "/logo-full.png",
};

export const COMPANY = {
  name: "All Day Power Washing",
  shortName: "All Day Power Washing",
  phone: "719-644-6105",
  phoneHref: "tel:+17196446105",
  email: "alldaysupport@alldaypowerwashing.com",
  slogan: "We Don't Cut Corners. We Clean Them.",
  tagline: "Residential & Commercial Pressure Washing",
  serviceArea: "Colorado Springs, Denver metro & surrounding states by request",
  address: {
    street: "3595 East Fountain Blvd, Suite 100D",
    city: "Colorado Springs",
    state: "CO",
    zip: "80910",
    full: "3595 East Fountain Blvd, Suite 100D, Colorado Springs, CO 80910",
  },
  hours: "Open 24 hours",
  veteranOwned: true,
  productionUrl: "https://www.alldaypowerwashing.com/",
  googleMapsUrl: "https://www.google.com/maps/place/All+Day+Power+Washing/data=!4m2!3m1!1s0x0:0x3ff0be1f6dc7b581",
  social: {
    facebook: "https://www.facebook.com/alldaypowerwashing",
    youtube: "https://www.youtube.com/@AllDayPowerWashing-oy3vw",
    bbb: "https://www.bbb.org/us/co/colorado-springs/profile/pressure-washing/all-day-power-washing-0785-1000032094",
    google: "https://www.google.com/maps/place/All+Day+Power+Washing/data=!4m2!3m1!1s0x0:0x3ff0be1f6dc7b581",
  },
};

export const SERVICES = [
  {
    id: "power-washing",
    name: "Power Washing",
    short: "High-pressure exterior washing for driveways, decks, patios & more.",
    basePrice: { small: [120, 220], medium: [220, 420], large: [420, 750], xlarge: [750, 1400] },
    icon: "Droplets",
  },
  {
    id: "concrete-cleaning",
    name: "Concrete Cleaning",
    short: "Commercial-grade surface cleaning for sidewalks, lots & pads.",
    basePrice: { small: [180, 320], medium: [320, 600], large: [600, 1100], xlarge: [1100, 2400] },
    icon: "Square",
  },
  {
    id: "gutter-cleaning",
    name: "Gutter Cleaning",
    short: "Clear downspouts, flush lines & protect your roof line.",
    basePrice: { small: [140, 240], medium: [240, 380], large: [380, 620], xlarge: [620, 1000] },
    icon: "CloudRain",
  },
  {
    id: "house-washing",
    name: "House Washing",
    short: "Soft-wash siding cleaning that kills mildew & restores curb appeal.",
    basePrice: { small: [220, 380], medium: [380, 620], large: [620, 980], xlarge: [980, 1600] },
    icon: "Home",
  },
  {
    id: "fleet-heavy-equipment",
    name: "Commercial / Fleet / Heavy Equipment",
    short: "Heavy-duty rig cleaning for trucks, trailers & industrial fleets.",
    basePrice: { small: [180, 320], medium: [320, 640], large: [640, 1200], xlarge: [1200, 3000] },
    icon: "Truck",
  },
  {
    id: "kitchen-hood",
    name: "Kitchen Hood Cleaning",
    short: "NFPA-96 style exhaust hood & duct degreasing for restaurants.",
    basePrice: { small: [280, 480], medium: [480, 820], large: [820, 1400], xlarge: [1400, 2800] },
    icon: "ChefHat",
  },
  {
    id: "epoxy-floor-coating",
    name: "Epoxy Floor Coating",
    short: "Durable epoxy for residential & commercial garages — solid, metallic, or flake.",
    basePrice: { small: [1500, 2400], medium: [2400, 4200], large: [4200, 7500], xlarge: [7500, 14000] },
    icon: "LayoutGrid",
    href: "/epoxy",
  },
];

export const SIZE_TIERS = [
  { id: "small", label: "Small", res: "Up to 1,500 sq ft", com: "Up to 2,500 sq ft" },
  { id: "medium", label: "Medium", res: "1,500 – 3,000 sq ft", com: "2,500 – 7,500 sq ft" },
  { id: "large", label: "Large", res: "3,000 – 5,000 sq ft", com: "7,500 – 20,000 sq ft" },
  { id: "xlarge", label: "X-Large", res: "5,000+ sq ft", com: "20,000+ sq ft" },
];

export const TRUST_BADGES = [
  "Veteran Owned & Operated",
  "Licensed & Insured",
  "100% Satisfaction Guarantee",
  "Heavy-Duty Equipment",
  "Residential & Commercial",
];

export const WHY_US = [
  { title: "100% Guarantee", body: "If it's not right, we make it right. No fine print." },
  { title: "Heavy-Duty Equipment", body: "Commercial-grade rigs and pro surface cleaners handle whatever your property throws at us." },
  { title: "Residential & Commercial", body: "From driveways to fleets and kitchen hoods — one crew, every job." },
  { title: "Local & Responsive", body: "Same-week quotes across Colorado Springs & the Denver metro." },
  { title: "Insured Professionals", body: "Fully insured. Your property is always protected." },
  { title: "We Show Up", body: "On time. In uniform. With the right gear. Every single visit." },
];

export const TESTIMONIALS = [
  { name: "Marcus T.", role: "Gas Station Owner", body: "Our lot hasn't looked this clean in years. Oil spots gone. Night crew was quiet and fast.", stars: 5 },
  { name: "Lindsey P.", role: "Homeowner", body: "House looks brand new. They soft-washed the siding and cleaned my gutters same day.", stars: 5 },
  { name: "Jorge M.", role: "Fleet Manager", body: "Trucks were buried in road grime. Their rig peeled it right off. Booked monthly now.", stars: 5 },
  { name: "Kim R.", role: "Restaurant Owner", body: "Hood cleaning was on-time, thorough, and the paperwork was ready for the inspector.", stars: 5 },
  { name: "Dave L.", role: "Property Manager", body: "Four shopping-center pads in one night. Tenants noticed the next morning. Huge win.", stars: 5 },
  { name: "Sarah B.", role: "HOA Board", body: "Clubhouse, sidewalks, pool deck — all on budget. Professional from quote to walkthrough.", stars: 5 },
];

export const GALLERY_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_sparkle-sales-12/artifacts/zu8ks40m_IMG_2684.jpg",
    caption: "Parking Garage Night Clean",
    tag: "Commercial · Multi-Level",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sparkle-sales-12/artifacts/rxtimm38_IMG_5282.jpg",
    caption: "On-Location Service Call",
    tag: "Downtown · Night Shift",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sparkle-sales-12/artifacts/hrc5esvr_IMG_3889.jpg",
    caption: "Gas Pump Pad Degrease",
    tag: "Commercial · Oil & Grime",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a46bee3e-c31a-4fea-95c5-6cc68884d7ce/artifacts/0mbaxeto_370148672_289206103863104_7590141916076419690_n%20-%20Copy.jpg",
    caption: "Gas Station Lot Surface Clean",
    tag: "Commercial Lot",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sparkle-sales-12/artifacts/huw4s54i_IMG_4047.jpg",
    caption: "Storefront Sidewalk Clean",
    tag: "Retail · High Traffic",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a46bee3e-c31a-4fea-95c5-6cc68884d7ce/artifacts/yz8m2n73_411082991_351954760921571_5656169685067536148_n.jpg",
    caption: "Heavy Equipment Wash",
    tag: "Military / Fleet",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sparkle-sales-12/artifacts/slbl6by9_IMG_5969.jpg",
    caption: "Car Wash Facility Pads",
    tag: "Commercial · Sunset Job",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a46bee3e-c31a-4fea-95c5-6cc68884d7ce/artifacts/3wlxryaa_Good%202%20Go%20Pumps%20-%20Copy.jpg",
    caption: "Concrete & Trash Pads",
    tag: "Heavy-Duty Surface Clean",
  },
];
